import { i18next } from 'flow/configure-locale';

export const capitalizeFirstLetter = (string: string) => {
    if (!string || string.length < 1) {
        return '';
    }
    const lowerCaseString = string.toLowerCase();
    return lowerCaseString.charAt(0).toUpperCase() + lowerCaseString.slice(1);
};

export const getTextLabel = (label: string) => {
    if (i18next.exists(label)) {
        return i18next.t(label);
    }
    //legacy remove when all CTI wrappers is updated with translation text label
    return capitalizeFirstLetter(label);
};

export const maskString = (string: string) => {
    if (string) return '*****';
    return '';
};
